// File placeholder viene sovrascritto in fase di build dallo script set-version.js
export const APP_VERSION = '1.11.0-beta.77';
